// ** Reducers Imports
import app from './slicer/appSlice'

const rootReducer = {
  app,
}

export default rootReducer
